import { render, staticRenderFns } from "./LexonSelectFormComponent.vue?vue&type=template&id=08a4308a"
import script from "./LexonSelectFormComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LexonSelectFormComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a4308a')) {
      api.createRecord('08a4308a', component.options)
    } else {
      api.reload('08a4308a', component.options)
    }
    module.hot.accept("./LexonSelectFormComponent.vue?vue&type=template&id=08a4308a", function () {
      api.rerender('08a4308a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonSelect/LexonSelectFormComponent.vue"
export default component.exports